<template>
    <div id="header" class="d-print-none">
        <div class="container">
            <header class="d-flex flex-wrap justify-content-center py-3 align-items-center">
                <a href="https://www.ethospreparedness.com/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none">
                    <img id="logo" src="/img/logos/ethos-logo.svg" />
                </a>
                <a href="https://www.ethospreparedness.com/organizations/contact-us.html" target="_new" class="btn btn-danger">Contact Us</a>
            </header>
        </div>
    </div>
    <div class="text-center d-none d-print-block">
        <img src="/img/logos/ethos-print-logo.svg" height="75" class="d-inline-block my-2" />
    </div>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'App',
};
</script>